import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"

const urlFligth = "Fligth"

export const getVueloCotizacion = async ({IdCotizacion}) =>{
    return axios.get(`${APIURL}/${urlFligth}/Quotation/${IdCotizacion}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}